module.exports = __webpack_public_path__ + "assets/GTAmerica-ExpandedRegular.woff2";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GTAmerica-ExpandedRegular.woff2
// module id = 1005
// module chunks = 19